module.exports = __webpack_public_path__ + "static/fonts/ionicons.143146f.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/view-design/src/styles/common/iconfont/fonts/ionicons.woff2?v=3.0.0
// module id = JPCy
// module chunks = 46